// src/config/eventConfig.ts
export const eventConfig = {
  eventDate: "2026-07-11T10:00:00",
  venue: "De Director's Hotel, Beside Market Square, Jikwoyi Phase 1",
  city: "Abuja",
} as const;

export type EventConfig = typeof eventConfig;
